import { FunctionsHttpError } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'

export type Alerta = {
  id: string
  marcaId: string
  marca: string
  data: string
  tipo: string
  severidade: 'atencao' | 'critico'
  titulo: string
  texto: string
  painel: 'trafego_pago' | 'organico' | 'leads' | null
  geradoEm: string
}

/** Os alertas das marcas visíveis (o RLS recorta) dos últimos `dias`. */
export async function listarAlertas(marcaId: string | null, dias = 30): Promise<Alerta[]> {
  const desde = new Date(Date.now() - dias * 86_400_000).toISOString().slice(0, 10)
  let q = supabase
    .from('alertas')
    .select('id, marca_id, data, tipo, severidade, titulo, texto, painel, gerado_em, marcas(nome)')
    .gte('data', desde)
    .order('data', { ascending: false })
    .order('severidade', { ascending: true })
    .limit(300)
  if (marcaId) q = q.eq('marca_id', marcaId)
  const { data, error } = await q
  if (error) throw new Error(error.message)
  return (data ?? []).map((r) => ({
    id: r.id,
    marcaId: r.marca_id,
    marca: (r.marcas as unknown as { nome: string } | null)?.nome ?? '',
    data: r.data,
    tipo: r.tipo,
    severidade: r.severidade,
    titulo: r.titulo,
    texto: r.texto,
    painel: r.painel,
    geradoEm: r.gerado_em,
  }))
}

/** Roda a verificação agora (quem gerencia marcas), para uma marca ou todas. */
export async function verificarAgora(marcaId: string | null): Promise<void> {
  const { error } = await supabase.functions.invoke('gerar-alertas', { body: { marca_id: marcaId } })
  if (error) {
    const detalhe = error instanceof FunctionsHttpError ? await error.context.json().catch(() => null) : null
    throw new Error(detalhe?.erro ?? error.message)
  }
}

// O que já foi visto fica neste navegador (conveniência; o alerta em si é do banco).
const VISTO = 'marketinghub:alertas-visto'
export function lerVisto(): string {
  try {
    return localStorage.getItem(VISTO) ?? ''
  } catch {
    return ''
  }
}
export function marcarVisto() {
  try {
    localStorage.setItem(VISTO, new Date().toISOString())
  } catch {
    // sem armazenamento: o sino só volta a contar ao recarregar
  }
}

export type PreferenciaAlertas = { porEmail: boolean; soCriticos: boolean }

/** A escolha de quem está logado (sem linha = não recebe). */
export async function lerPreferenciaAlertas(): Promise<PreferenciaAlertas> {
  const { data, error } = await supabase.from('alertas_preferencias').select('por_email, so_criticos').maybeSingle()
  if (error) throw new Error(error.message)
  return { porEmail: Boolean(data?.por_email), soCriticos: Boolean(data?.so_criticos) }
}

/** Grava a escolha da própria pessoa (o banco não deixa mexer na de outra). */
export async function salvarPreferenciaAlertas(usuarioId: string, p: PreferenciaAlertas): Promise<void> {
  const { data, error } = await supabase
    .from('alertas_preferencias')
    .upsert({ usuario_id: usuarioId, por_email: p.porEmail, so_criticos: p.soCriticos, atualizado_em: new Date().toISOString() })
    .select('usuario_id')
  if (error) throw new Error(error.message)
  if (!data?.length) throw new Error('Não foi possível salvar a preferência')
}
